<template>
  <div class="container">
    <Advbar></Advbar>
    <div class="main">
      <div class="left">
        <div class="left1">
          <Categorytree @treeclick="navclick"/>
        </div>
        <div class="left2">
          <Newsbar/>
        </div>
        <div class="left3">
          <Contactbar/>
        </div>
      </div>
      <v-card  color="grey lighten-4" outlined class="right mt-2 ml-2">
        <v-sheet
          class="pl-4 d-flex justify-start align-center"
          height="40"
          color="light-blue darken-3 white--text">
          <div class="divider"></div>
          <span>{{recruitment[$store.state.lang+'_title']}}</span>
        </v-sheet>
        <v-sheet
          class="pa-4"
          color="grey lighten-4"
          v-html="recruitment[$store.state.lang+'_content']">
        </v-sheet>
      </v-card>
    </div>
  </div>
</template>

<script>
import Advbar from '@/components/Advbar.vue'
import Categorytree from '@/components/Categorytree.vue'
import Newsbar from '@/components/Newsbar.vue'
import Contactbar from '@/components/Contactbar.vue'

export default {
  name: 'recruitment',
  components: {
    Categorytree,
    Newsbar,
    Advbar,
    Contactbar,
  },
  data(){
    return{
      recruitment_io_api:'recruitment/io/',
      recruitment:'',
      bread_io_api:'bread/io/',
      bread:[],
    }
  },
  computed:{
    flag(){
      return this.$route.query.flag;
    }
  },
  methods:{
    navclick(val){
      this.$router.push({
        path:'/productlist',
        query:{
          flag:val,
          ischild:'false',
        },
      });
    },
    fetch(){
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.recruitment_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.recruitment = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
    fetch_bread(){
      let postdata = {};
      postdata.flagid = this.flag;
      this.$axios.post(this.$store.state.baseurl + this.bread_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.bread = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
    this.fetch_bread();
  }
}
</script>

<style scoped>
.main{
  display:flex;
}
.left{
  width:25%;
}
.left1{
  min-height:300px;
  margin-top:8px;
}
.left2{
  margin-top:8px;
}
.left3{
  min-height:300px;
  margin-top:8px;
}
.right{
  width:75%;
}
</style>
